module.exports = __webpack_public_path__ + "media/images/iconTrendDown__inactive-77872cf4155d338837b6d14859ce53b9.png";